<template lang="pug">
ul.FChaptersList(:style="style")
  li.FChaptersList__chapter(
    v-for="chapter in chapters"
    :key="chapter.value"
  )
    p {{ chapter.prefix }} {{ chapter.value }}
    h5 {{ chapter.text }}
</template>

<style lang="stylus">
.FChaptersList
  color var(--FChaptersList--color)
  padding 0
  list-style none

.FChaptersList__chapter
  margin-bottom rem(24)
</style>

<script setup lang="ts">
export interface Chapter {
  prefix: string;
  value: string;
  text: string;
}

export interface FChaptersListProps {
  /**
   * Color of the text
   */
  color?: Color;
  /**
   * List of chapters
   */
  chapters: Chapter[];
}

const props = withDefaults(defineProps<FChaptersListProps>(), {
  color: 'secondary',
});

const style = computed(
  (): Style => ({
    '--FChaptersList--color': getCssColor(props.color),
  })
);
</script>
